import React, { Component } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import TextField from 'react-md/lib/TextFields';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Recaptcha from 'react-google-recaptcha';

import './OfferForm.css';
import './ReservationForm.css';

const RECAPTCHA_KEY = '6Le9TlwUAAAAANmO2Rf-jvcn8xZ2OLCsvN27evxG';

const encode = (data) => {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");
}

class ReservationForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      subject: 'Gaijin ' + (this.props.intl.locale ==="fi"?'varaustiedustelu':'reservation request'),
	  language: this.props.intl.locale,
      date: '',
      time: '',
      people: '',
      wishes: '',
      name: '',
      email: '',
      phone: '',
      billing: '',
      success: false,
      error: false,
    }
  }

  handleChange(field, value) {
    this.setState({
      [field]: value
    });
  }
  
  handleRecaptcha(value) {
    this.setState({ "g-recaptcha-response": value });
  };

  handleSubmit(e) {
    e.preventDefault();

    if(this.state.date && this.state.time && this.state.people && this.state.wishes && this.state.name && this.state.email && this.state.phone) {
      fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: encode({ "form-name": "reservation", ...this.state })
      })
      .then(() => this.setState({ success: true, error: false }))
      .catch(error => this.setState({ success: false, error: true }))
    }
    else {
      this.setState({ error: true })
    }
  }

  render() {
    if(this.props.intl.locale==='fi') {
      let fiLocale = require('moment/locale/fi');
      moment.locale('fi', fiLocale);
    }

    return (
      <div className="offer reservation">
      <h3>{this.props.intl.messages["groupReservation.heading"]}</h3>

        { !this.state.success &&
          <form name="reservation" onSubmit={this.handleSubmit.bind(this)} data-netlify-recaptcha="true">
            <input type="hidden" name="form-name" value="reservation" />
            <input type="hidden" name="bot-field" value="" />
            <fieldset>
              <div>
                {this.state.date && <div className="datepicker-wrapper"><label htmlFor="date" className="md-floating-label md-floating-label--floating">{this.props.intl.messages["groupReservation.date"]}</label></div>}
                <DatePicker locale="fi" placeholderText={this.props.intl.messages["groupReservation.date"]} selected={this.state.date} onChange={(e) => this.setState({date: e})} minDate={moment()} maxDate={moment().add(365, "days")} />
              </div>
              <div>
                <TextField id="time" label={this.props.intl.messages["groupReservation.time"]} onChange={(e) => this.handleChange('time', e)} required />
              </div>
              <div>
                <TextField id="people" label={this.props.intl.messages["groupReservation.people"]} onChange={(e) => this.handleChange('people', e)} required />
              </div>
              <div>
                <TextField id="wishes" label={this.props.intl.messages["groupReservation.wishes"]} onChange={(e) => this.handleChange('wishes', e)} required />
              </div>
              <div>
                <TextField id="name" label={this.props.intl.messages["groupReservation.name"]} onChange={(e) => this.handleChange('name', e)} required />
              </div>
              <div>
                <TextField id="email" type="email" label={this.props.intl.messages["groupReservation.email"]} onChange={(e) => this.handleChange('email', e)} required />
              </div>
              <div>
                <TextField id="phone" type="tel" label={this.props.intl.messages["groupReservation.phone"]} onChange={(e) => this.handleChange('phone', e)} required />
              </div>
              <div>
                <TextField id="budget" label={this.props.intl.messages["groupReservation.billing"]} onChange={(e) => this.handleChange('billing', e)} />
              </div>
            </fieldset>

            <p>{this.props.intl.messages["groupReservation.notice"]}</p>
            <br/>
            <Recaptcha
              ref="recaptcha"
              sitekey={RECAPTCHA_KEY}
              onChange={(val) => this.handleRecaptcha(val)}
              theme="dark"
            />
            <br/>            
            <button disabled={!this.state['g-recaptcha-response']} className="btn" type="submit">{this.props.intl.messages["general.sendRequest"]}</button>
            
          </form>
        }
        { !this.state.success && this.state.error &&
          <p className="fail">
            {this.props.intl.messages["groupReservation.fail"]}
          </p>
        }
        {
          this.state.success &&
          <p className="success">
            {this.props.intl.messages["groupReservation.success"]}
          </p>
        }
      </div>
    )
  }
}

ReservationForm.propTypes = {
  intl: intlShape.isRequired,
}

export default injectIntl(ReservationForm)



// WEBPACK FOOTER //
// ./src/components/ReservationForm.js